(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reports"] && !Shopify.designMode) return;
  try {
    

(function () {

  const root = document.getElementById(
    'rooted-lab-reports-{{ section.id }}'
  );

  if (!root) return;

  const searchInput = root.querySelector(
    '#rh-report-search-{{ section.id }}'
  );

  const filter = root.querySelector(
    '#rh-report-filter-{{ section.id }}'
  );

  const cards = Array.from(
    root.querySelectorAll('.rh-report-card')
  );

  const noResults = root.querySelector(
    '#rh-no-results-{{ section.id }}'
  );

  const modal = root.querySelector(
    '#rh-pdf-modal-{{ section.id }}'
  );

  const modalFrame = root.querySelector(
    '#rh-pdf-frame-{{ section.id }}'
  );

  const modalTitle = root.querySelector(
    '#rh-pdf-title-{{ section.id }}'
  );

  const closeButton = root.querySelector(
    '.rh-pdf-close'
  );

  const overlay = root.querySelector(
    '.rh-pdf-overlay'
  );


  function filterReports() {

    const searchValue = (
      searchInput.value || ''
    ).toLowerCase().trim();

    const filterValue = filter.value;

    let visible = 0;

    cards.forEach(function (card) {

      const title = (
        card.dataset.title || ''
      ).toLowerCase();

      const category = (
        card.dataset.category || ''
      ).toLowerCase();

      const matchesSearch =
        !searchValue ||
        title.includes(searchValue);

      const matchesCategory =
        filterValue === 'all' ||
        category === filterValue;

      if (
        matchesSearch &&
        matchesCategory
      ) {
        card.style.display = '';
        visible++;
      } else {
        card.style.display = 'none';
      }

    });

    noResults.classList.toggle(
      'active',
      visible === 0
    );

  }


  function openPdf(url, title) {

    if (!url) return;

    modalTitle.textContent =
      title || 'Lab Report';

    /*
      Hide the browser PDF toolbar where supported.
      This is a viewing-only interface.
    */

    let viewerUrl = url;

    if (url.indexOf('#') === -1) {
      viewerUrl =
        url +
        '#toolbar=0&navpanes=0&scrollbar=1';
    }

    modalFrame.src = viewerUrl;

    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');

    document.documentElement.style.overflow =
      'hidden';

  }


  function closePdf() {

    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');

    modalFrame.src = '';

    document.documentElement.style.overflow =
      '';

  }


  if (searchInput) {
    searchInput.addEventListener(
      'input',
      filterReports
    );
  }

  if (filter) {
    filter.addEventListener(
      'change',
      filterReports
    );
  }


  closeButton.addEventListener(
    'click',
    closePdf
  );

  overlay.addEventListener(
    'click',
    closePdf
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        modal.classList.contains('active')
      ) {
        closePdf();
      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();
})();
